export default "__VITE_ASSET__ndk0Lxw8__"